.stack {
  grid-column: 1 / -1;
  display: grid;
  gap: var(--gap);
  min-width: 0;
}

/* The short line under a tile's figure. */
.tileNote {
  color: var(--muted);
  font-size: var(--t-min);
}

.events {
  width: 100%;
  margin: 0;
  border-collapse: collapse;
}

.events th {
  padding: 6px 12px 6px 0;
  text-align: start;
  font-size: var(--t-min);
  font-weight: 600;
  color: var(--muted);
}

.event > td {
  min-width: 0;
  padding: 10px 12px 10px 0;
  vertical-align: baseline;
  border-top: 1px solid var(--line);
  overflow-wrap: anywhere;
  color: var(--ink-2);
}

.time {
  font-size: var(--t-min);
  font-variant-numeric: lining-nums tabular-nums;
  color: var(--muted);
}

.type {
  font-family: var(--mono);
  font-weight: 650;
  color: var(--ink);
}

.actor {
  font-family: var(--mono);
  font-size: var(--t-min);
}

.reason {
  color: var(--ink-2);
}

.attribution {
  margin: 0 0 8px;
  font-size: var(--t-min);
  line-height: 1.6;
  overflow-wrap: anywhere;
  color: var(--muted);
}

.export {
  flex-shrink: 0;
  /* In the Admin log's column the button is a button, not a bar across the page. */
  place-self: start;
  max-width: 100%;
}

.paging {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
}
